var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 114,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.7 28 1.6 28.3 27.5 7.3-26.5 10.2 1.6 28.4-18-22-26.4 10.3 15.3-24-18-21.9 27.5 7.2L57.7 28ZM81.2 23.1l1.2 8.7 8.6 1.6-7.9 3.8 1.2 8.7-6-6.3-8 3.8 4.2-7.7-6.1-6.4L77 31l4.2-7.8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m78.5 75 2.7 8h8.3l-6.7 5 2.6 7.8-6.8-4.8-6.7 5 2.5-8-6.8-4.9H76l2.5-8ZM23.3 7.6l9 9.6L44 11.6l-6.3 11.5 9 9.5L33.8 30l-6.3 11.5-1.6-13-12.8-2.4 11.8-5.6-1.6-13Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTokenIcon);
export default __webpack_public_path__ + "static/media/menu-token-icon.67ce918f3bdf13f9c860a93da65afe90.svg";
export { ForwardRef as ReactComponent };